import { render } from "./sidebar.component.vue?vue&type=template&id=6f048b59"
import script from "./sidebar.component.vue?vue&type=script&lang=js"
export * from "./sidebar.component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__